module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--02.0b5849a4.png";